import React from "react";

export default function () {
  return <div className="card__mark"> </div>;
}
